import base from './base';

var detail = require('base/product/detail');
var teasersModules = require('turnToCustom/teaser/teasersModules');

detail.updateAvailability = function updateAvailability() {
    $('body').on('product:updateAvailability', function (e, response) {
        $('div.availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available);
        if ($('.dw-apple-pay-button').length) {
            $('.applepay-container').attr('data-readytoorder', response.product.readyToOrder);
            $('.applepay-container').addClass('enabled').removeClass('enabled'); // Added to force UI update since safari does not consistently update UI
        }
        $('.availability-msg').removeClass('custom-error').empty().html(response.message);
        $('.preorder-status', response.$productContainer).empty().html(response.preOrderStatus);
        $('.product-detail__imgbadges', response.$productContainer).empty().html(response.badges);
        if ($('.buy-box__brand-badges').length) {
            $('.buy-box__brand-badges', response.$productContainer).empty().html(response.badges);
        }
        $('.pdp-badge').empty();
        let siteName = ($('.page').data('sitename') || '').toUpperCase();
        var $saleBadges = $(response.saleBadges);
        var finalSaleText = $saleBadges.filter('.product-detail__salebadges-text').not('.inventory-msg').first().text() || '';
        finalSaleText = finalSaleText.trim();

        var lowInventoryText = $saleBadges.filter('.inventory-msg').text() || '';
        lowInventoryText = lowInventoryText.trim();

        var badges = response.product.ImagebadgeSkuLevelStatus;
        var isCK = siteName === 'PVHCKUS' || siteName === 'PVHCKCA';
        var isTH = siteName === 'PVHTHUS' || siteName === 'PVHTHCA';
        var allBadges = [];

        if (isCK) {
            allBadges = ['imageBadge1', 'imageBadge2', 'imageBadge3'];
        } else if (isTH) {
            allBadges = ['imageBadge2', 'imageBadge3', 'imageBadge1'];
        }

        allBadges.forEach(function (badgeKey, index) {
            var badgeValue = badges[badgeKey];
            if (badgeValue != null) {
                var isFinalSaleMatch = (finalSaleText && badgeValue === finalSaleText);
                var isLowInventoryMatch = (lowInventoryText && badgeValue === lowInventoryText);

                if (!(isFinalSaleMatch || isLowInventoryMatch)) {
                    $('.buy-box__imgbadges:nth-child(' + (index + 1) + ')', response.$productContainer).html(badgeValue);
                }
            }
        });

        $('.product-detail__salebadges', response.$productContainer).empty().html(response.saleBadges);
        if ($('.global-availability').length) {
            var allAvailable = $('.product-availability').toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability').toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability')
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg').empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        }
    });
};

detail.updateAttribute = function updateAttribute() {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.product-detail>.bundle-items').length) {
            response.container.data('pid', response.data.product.id);
            response.container.find('.product-id').text(response.data.product.id);
        } else if ($('.product-set-detail').eq(0)) {
            response.container.data('pid', response.data.product.id);
            response.container.find('.product-id').text(response.data.product.id);
        } else {
            $('.product-id').text(response.data.product.id);
            $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
        }
        // TurnTo Integration
        TurnToCmd('set', { sku: response.data.product.id }); // eslint-disable-line new-cap
        teasersModules.loadTeaserCounts(response.data.product.id);
        // TurnToCmd('gallery.set', { skus: [response.data.product.id] });
    });
};

detail.cyberSourceUpdateAddToCart = function cyberSourceUpdateAddToCart() {
    $('body').on('product:updateAddToCart', function (e, response) {
        if (response.product.readyToOrder) {
            var applePayButton = $('.apple-pay-pdp', response.$productContainer);
            if (applePayButton.length !== 0) {
                applePayButton.attr('sku', response.product.id);
            } else {
                if ($('.apple-pay-pdp').length === 0) { // eslint-disable-line no-lonely-if
                    $('.cart-and-ipay').append('<isapplepay class="apple-pay-pdp btn"'
                        + 'sku=' + response.product.id + '></isapplepay>');
                }
            }
        } else {
            $('.apple-pay-pdp').remove();
        }
    });
};

detail.createCookieFindingMethod = function createCookieFindingMethod() {
    cookieSet.delete('finding_method');
};

export default {
    ...detail,
    ...base
};
